// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__dRfxW","copyright":"Footer_copyright__HRK+-"};